import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import ProjectDashboard from "./components/ProjectDashboard";
import AuthenticationCheck from "./components/AuthenticationCheck";
import ApiAuthProvider from "./components/ApiAuthProvider";
import { UserRoleProvider } from "./context/UserRoleContext";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import PwaBottomNav from "./components/PwaBottomNav";
import PwaUiSync from "./components/PwaUiSync";
import PwaUpdateManager from "./components/PwaUpdateManager";
import CrewTimesheetFlowHost from "./components/CrewTimesheetFlowHost";
import { isPwaApp } from "./config/appMode";

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const [isMsalInitialized, setIsMsalInitialized] = useState(false);

  // Initialize MSAL on component mount
  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize();
        await msalInstance.handleRedirectPromise();
        setIsMsalInitialized(true);
      } catch (error) {
        console.error("MSAL initialization failed:", error);
      }
    };
    initializeMsal();
  }, []);

  if (!isMsalInitialized) {
    return <div>Loading MSAL...</div>;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        {isPwaApp && <PwaUiSync />}
        {isPwaApp && <PwaUpdateManager />}
        <AuthenticationCheck>
          <ApiAuthProvider>
          <UserRoleProvider>
          <CrewTimesheetFlowHost />
          <Routes>
            <Route path="/" element={<ProjectDashboard />} />
            <Route path="/dashboard" element={<ProjectDashboard />} />
            <Route path="/project/:projectId" element={<ProjectDashboard />} />
            <Route path="/contacts" element={<ProjectDashboard />} />
            <Route path="/contacts/manage" element={<ProjectDashboard />} />
            <Route path="/accounts" element={<ProjectDashboard />} />
            <Route path="/inventory" element={<ProjectDashboard />} />
            <Route path="/equipment" element={<ProjectDashboard />} />
            <Route path="/archive" element={<ProjectDashboard />} />
            <Route path="/configuration" element={<ProjectDashboard />} />
            <Route path="/configuration/stock-inventory" element={<ProjectDashboard />} />
            <Route path="/configuration/labor-scope-codes" element={<ProjectDashboard />} />
            <Route path="/configuration/equipment-time-cards" element={<ProjectDashboard />} />
            <Route path="/configuration/projects-production-performance-data" element={<ProjectDashboard />} />
          </Routes>
          {isPwaApp && <PWAInstallPrompt />}
          {isPwaApp && <PwaBottomNav />}
          </UserRoleProvider>
          </ApiAuthProvider>
        </AuthenticationCheck>
      </Router>
    </MsalProvider>
  );
}

export default App;
